module.exports = __webpack_public_path__ + "img/22-4.2ed79eb8.png";